require('intersection-observer');

import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import lozad from 'lozad';

const observer = lozad('.lozad', {
    rootMargin: '50px 0px', // syntax similar to that of CSS Margin
    threshold: 0.1, // ratio of element convergence
});
observer.observe();

Alpine.plugin(focus);

window.Alpine = Alpine;

// Global cookie functions (used by cookie banner).
window.setCookie = function(name, value, days) {
    let expires = ''
    if (days) {
        const date = new Date()
        date.setTime(date.getTime() + (days*24*60*60*1000))
        expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + (value || '')  + expires + '; path=/'
}

window.eraseCookie = function(name) {
    document.cookie = name+'=; Max-Age=-99999999;'
}

window.getCookie = function(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

Alpine.start();
